import { useState, useEffect, useRef, useCallback } from 'react'

const THRESHOLD = 60

export function usePullToRefresh(onRefresh) {
  const [pullDistance, setPullDistance] = useState(0)
  const [refreshing, setRefreshing] = useState(false)
  const startY = useRef(0)
  const pulling = useRef(false)

  const handleTouchStart = useCallback((e) => {
    if (window.scrollY === 0 && !refreshing) {
      startY.current = e.touches[0].clientY
      pulling.current = true
    }
  }, [refreshing])

  const handleTouchMove = useCallback((e) => {
    if (!pulling.current) return
    const dy = e.touches[0].clientY - startY.current
    if (dy > 0) {
      setPullDistance(Math.min(dy * 0.5, 100))
    } else {
      pulling.current = false
      setPullDistance(0)
    }
  }, [])

  const handleTouchEnd = useCallback(async () => {
    if (!pulling.current) return
    pulling.current = false
    if (pullDistance >= THRESHOLD && onRefresh) {
      setRefreshing(true)
      setPullDistance(0)
      try {
        await onRefresh()
      } finally {
        setRefreshing(false)
      }
    } else {
      setPullDistance(0)
    }
  }, [pullDistance, onRefresh])

  useEffect(() => {
    window.addEventListener('touchstart', handleTouchStart, { passive: true })
    window.addEventListener('touchmove', handleTouchMove, { passive: true })
    window.addEventListener('touchend', handleTouchEnd)
    return () => {
      window.removeEventListener('touchstart', handleTouchStart)
      window.removeEventListener('touchmove', handleTouchMove)
      window.removeEventListener('touchend', handleTouchEnd)
    }
  }, [handleTouchStart, handleTouchMove, handleTouchEnd])

  return { pullDistance, refreshing }
}
